const updateSelectedProduct = (state, { payload: { product } }) => {
	state.selectedProduct = product;
};

export default updateSelectedProduct;
